
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher"

export class MigrateDocumentsCompanyCommand {
    constructor(
        private readonly dispatcher: CommandDispatcher,
        private readonly frontend
    ) {}
    async run(args) { // args : {document_ids:[number], from_company_id:number, dest_company_id:number, user_id:number}
        let res = undefined
        try {
            res = await this.dispatcher.dispatch_with_result('migrate.documents.company', args)
        } catch(error) {
            console.error('Error migrating documents to another company', error)
        } finally {
            if (res) {
                console.error('Error migrating documents to another company', res)
            }
            this.frontend.migrateDoneSelectedCompany = null
            this.frontend.loadingAction = false
            this.frontend.refreshData()
        }
    }
}